module.exports = __webpack_public_path__ + "static/typec-4a9918c295e37aaeb85e58d93719cb15.png";